const EmptyMsg = ({ children }) => (
  <div className="w-full italic text-center text-gray-600">
    {children}
  </div>
)

export default EmptyMsg